import NodeRenderer from "./NodeRenderer";

const LayoutRenderer = ({ layoutConfig = [], parentId = null, ...nodeRendererProps }) => {
  return (
    <>
      {layoutConfig.map((node) => (
        <NodeRenderer key={node.id} node={node} parentId={parentId} {...nodeRendererProps} />
      ))}
    </>
  );
};

export default LayoutRenderer;
